import { apiRequest } from '../apiRequest';
import { 
  SAVE_USER_ENDPOINT,
  UPDATE_USER_ENDPOINT, 
  FETCH_USER_ENDPOINT, 
} from '../urls';

export const saveUser = (data) => {
	return apiRequest('POST', SAVE_USER_ENDPOINT, data);
}

export const fetchUser = (data) => {
  return apiRequest('POST', FETCH_USER_ENDPOINT, data);
}

export const updateUser = (data) => {
  return apiRequest('POST', UPDATE_USER_ENDPOINT, data);
}

